/* tslint:disable */
/* eslint-disable */
/**
 * SIBR
 * SIBR Backend API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BookingCatalogOfferRequest } from '../model';
// @ts-ignore
import { Cart } from '../model';
// @ts-ignore
import { CartUpdateRequest } from '../model';
// @ts-ignore
import { CatalogMultiOffersBookingRequest } from '../model';
// @ts-ignore
import { OutputErrorMessage } from '../model';
// @ts-ignore
import { TripBookingRequest } from '../model';
/**
 * BookingControllerApi - axios parameter creator
 * @export
 */
export const BookingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add an item in the cart and return the cart
         * @param {string} xBffKey bff key header
         * @param {TripBookingRequest} tripBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToCart: async (xBffKey: string, tripBookingRequest: TripBookingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('addToCart', 'xBffKey', xBffKey)
            // verify required parameter 'tripBookingRequest' is not null or undefined
            assertParamExists('addToCart', 'tripBookingRequest', tripBookingRequest)
            const localVarPath = `/api/v1/book`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tripBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a catalog offer in the cart and return the cart
         * @param {string} xBffKey bff key header
         * @param {BookingCatalogOfferRequest} bookingCatalogOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToCartCatalogOffer: async (xBffKey: string, bookingCatalogOfferRequest: BookingCatalogOfferRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('addToCartCatalogOffer', 'xBffKey', xBffKey)
            // verify required parameter 'bookingCatalogOfferRequest' is not null or undefined
            assertParamExists('addToCartCatalogOffer', 'bookingCatalogOfferRequest', bookingCatalogOfferRequest)
            const localVarPath = `/api/v1/book/offer/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingCatalogOfferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add multiple catalog offers in the cart and return the cart
         * @param {string} xBffKey bff key header
         * @param {CatalogMultiOffersBookingRequest} catalogMultiOffersBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToCartCatalogOffers: async (xBffKey: string, catalogMultiOffersBookingRequest: CatalogMultiOffersBookingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('addToCartCatalogOffers', 'xBffKey', xBffKey)
            // verify required parameter 'catalogMultiOffersBookingRequest' is not null or undefined
            assertParamExists('addToCartCatalogOffers', 'catalogMultiOffersBookingRequest', catalogMultiOffersBookingRequest)
            const localVarPath = `/api/v1/book/offers/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catalogMultiOffersBookingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an item from the cart and return the cart
         * @param {string} itemId 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItem: async (itemId: string, xBffKey: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('deleteItem', 'itemId', itemId)
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('deleteItem', 'xBffKey', xBffKey)
            const localVarPath = `/api/v1/carts/items/{itemId}`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the cart
         * @param {string} xBffKey bff key header
         * @param {boolean} [withServices] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCart: async (xBffKey: string, withServices?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('getCart', 'xBffKey', xBffKey)
            const localVarPath = `/api/v1/carts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (withServices !== undefined) {
                localVarQueryParameter['withServices'] = withServices;
            }

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update the cart and return the cart
         * @param {string} xBffKey bff key header
         * @param {CartUpdateRequest} cartUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCart: async (xBffKey: string, cartUpdateRequest: CartUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xBffKey' is not null or undefined
            assertParamExists('updateCart', 'xBffKey', xBffKey)
            // verify required parameter 'cartUpdateRequest' is not null or undefined
            assertParamExists('updateCart', 'cartUpdateRequest', cartUpdateRequest)
            const localVarPath = `/api/v1/book/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xBffKey != null) {
                localVarHeaderParameter['x-bff-key'] = String(xBffKey);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cartUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BookingControllerApi - functional programming interface
 * @export
 */
export const BookingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BookingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add an item in the cart and return the cart
         * @param {string} xBffKey bff key header
         * @param {TripBookingRequest} tripBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addToCart(xBffKey: string, tripBookingRequest: TripBookingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addToCart(xBffKey, tripBookingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add a catalog offer in the cart and return the cart
         * @param {string} xBffKey bff key header
         * @param {BookingCatalogOfferRequest} bookingCatalogOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addToCartCatalogOffer(xBffKey: string, bookingCatalogOfferRequest: BookingCatalogOfferRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addToCartCatalogOffer(xBffKey, bookingCatalogOfferRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add multiple catalog offers in the cart and return the cart
         * @param {string} xBffKey bff key header
         * @param {CatalogMultiOffersBookingRequest} catalogMultiOffersBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addToCartCatalogOffers(xBffKey: string, catalogMultiOffersBookingRequest: CatalogMultiOffersBookingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addToCartCatalogOffers(xBffKey, catalogMultiOffersBookingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete an item from the cart and return the cart
         * @param {string} itemId 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteItem(itemId: string, xBffKey: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteItem(itemId, xBffKey, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the cart
         * @param {string} xBffKey bff key header
         * @param {boolean} [withServices] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCart(xBffKey: string, withServices?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCart(xBffKey, withServices, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary update the cart and return the cart
         * @param {string} xBffKey bff key header
         * @param {CartUpdateRequest} cartUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCart(xBffKey: string, cartUpdateRequest: CartUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Cart>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCart(xBffKey, cartUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BookingControllerApi - factory interface
 * @export
 */
export const BookingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BookingControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Add an item in the cart and return the cart
         * @param {string} xBffKey bff key header
         * @param {TripBookingRequest} tripBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToCart(xBffKey: string, tripBookingRequest: TripBookingRequest, options?: any): AxiosPromise<Cart> {
            return localVarFp.addToCart(xBffKey, tripBookingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a catalog offer in the cart and return the cart
         * @param {string} xBffKey bff key header
         * @param {BookingCatalogOfferRequest} bookingCatalogOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToCartCatalogOffer(xBffKey: string, bookingCatalogOfferRequest: BookingCatalogOfferRequest, options?: any): AxiosPromise<Cart> {
            return localVarFp.addToCartCatalogOffer(xBffKey, bookingCatalogOfferRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add multiple catalog offers in the cart and return the cart
         * @param {string} xBffKey bff key header
         * @param {CatalogMultiOffersBookingRequest} catalogMultiOffersBookingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addToCartCatalogOffers(xBffKey: string, catalogMultiOffersBookingRequest: CatalogMultiOffersBookingRequest, options?: any): AxiosPromise<Cart> {
            return localVarFp.addToCartCatalogOffers(xBffKey, catalogMultiOffersBookingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an item from the cart and return the cart
         * @param {string} itemId 
         * @param {string} xBffKey bff key header
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteItem(itemId: string, xBffKey: string, options?: any): AxiosPromise<Cart> {
            return localVarFp.deleteItem(itemId, xBffKey, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the cart
         * @param {string} xBffKey bff key header
         * @param {boolean} [withServices] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCart(xBffKey: string, withServices?: boolean, options?: any): AxiosPromise<Cart> {
            return localVarFp.getCart(xBffKey, withServices, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update the cart and return the cart
         * @param {string} xBffKey bff key header
         * @param {CartUpdateRequest} cartUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCart(xBffKey: string, cartUpdateRequest: CartUpdateRequest, options?: any): AxiosPromise<Cart> {
            return localVarFp.updateCart(xBffKey, cartUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BookingControllerApi - object-oriented interface
 * @export
 * @class BookingControllerApi
 * @extends {BaseAPI}
 */
export class BookingControllerApi extends BaseAPI {
    /**
     * 
     * @summary Add an item in the cart and return the cart
     * @param {string} xBffKey bff key header
     * @param {TripBookingRequest} tripBookingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApi
     */
    public addToCart(xBffKey: string, tripBookingRequest: TripBookingRequest, options?: AxiosRequestConfig) {
        return BookingControllerApiFp(this.configuration).addToCart(xBffKey, tripBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a catalog offer in the cart and return the cart
     * @param {string} xBffKey bff key header
     * @param {BookingCatalogOfferRequest} bookingCatalogOfferRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApi
     */
    public addToCartCatalogOffer(xBffKey: string, bookingCatalogOfferRequest: BookingCatalogOfferRequest, options?: AxiosRequestConfig) {
        return BookingControllerApiFp(this.configuration).addToCartCatalogOffer(xBffKey, bookingCatalogOfferRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add multiple catalog offers in the cart and return the cart
     * @param {string} xBffKey bff key header
     * @param {CatalogMultiOffersBookingRequest} catalogMultiOffersBookingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApi
     */
    public addToCartCatalogOffers(xBffKey: string, catalogMultiOffersBookingRequest: CatalogMultiOffersBookingRequest, options?: AxiosRequestConfig) {
        return BookingControllerApiFp(this.configuration).addToCartCatalogOffers(xBffKey, catalogMultiOffersBookingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an item from the cart and return the cart
     * @param {string} itemId 
     * @param {string} xBffKey bff key header
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApi
     */
    public deleteItem(itemId: string, xBffKey: string, options?: AxiosRequestConfig) {
        return BookingControllerApiFp(this.configuration).deleteItem(itemId, xBffKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the cart
     * @param {string} xBffKey bff key header
     * @param {boolean} [withServices] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApi
     */
    public getCart(xBffKey: string, withServices?: boolean, options?: AxiosRequestConfig) {
        return BookingControllerApiFp(this.configuration).getCart(xBffKey, withServices, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update the cart and return the cart
     * @param {string} xBffKey bff key header
     * @param {CartUpdateRequest} cartUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingControllerApi
     */
    public updateCart(xBffKey: string, cartUpdateRequest: CartUpdateRequest, options?: AxiosRequestConfig) {
        return BookingControllerApiFp(this.configuration).updateCart(xBffKey, cartUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
